import Component from '@glimmer/component';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'callout payment-request {{if @isSelected \"enable\" \"disable\"}}\' ...attributes>\n  <div class=\'grid-x grid-padding-x\' data-test-on-select {{on \'click\' @onSelect}}>\n    <div class=\'cell medium-9\'>\n      {{yield to=\'header\'}}\n    </div>\n    <div class=\'cell medium-3 text-right\'>\n      {{yield to=\'logo\'}}\n    </div>\n  </div>\n  {{yield to=\'content\'}}\n</div>");

class PaymentMethodPaymentSectionComponent extends Component {}
setComponentTemplate(TEMPLATE, PaymentMethodPaymentSectionComponent);

export { PaymentMethodPaymentSectionComponent as default };
//# sourceMappingURL=payment-section.js.map
